// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';

export default class BookingSettingsSalesContact extends ApiObject {

  email: string;

  phone: string;
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/booking/BookingSettingsSalesContact.js